module.exports = __webpack_public_path__ + "static/img/8_blue.8ef539ee.jpg";